// action
export const setAppServerIpAddress = (data) => ({ type: 'APP_SERVER_IP_ADDRESS', payload: data });
// Reducers
export const setAppServerIpAddressReducer =
  (state = 'xvision-api-manu-prod.doriai.com',
    action = { type: '', payload: 'xvision-api-manu-prod.doriai.com' }) => {
    if (action.type === 'APP_SERVER_IP_ADDRESS') { return action.payload; } else { return state; }
  };
// Selectors
export const getAppServerIpAddress = (state) => state.appServerIpAddress;
